import { types } from 'mobx-state-tree';

export enum CouponType {
    /// <summary>
    /// Sázenka s jedním řádkem
    /// </summary>
    Solo = 1,

    /// <summary>
    /// Sázenka obsahuje jedinou kardinalitu, jejíž id (tzn mohutnost) je rovno počtu skupin bez tutovek. Jednoduše řečeno obshuje jediný tiket
    /// </summary>
    Ako = 2,

    /// <summary>
    /// Sázenka obsahuje několik tiketů
    /// </summary>
    System = 3
}

export enum CouponMode {
    /// <summary>
    /// Sázenka s jedním řádkem nebo sázenka s prostou kombinací řádků. Sázenka obsahuje jedinou kardinalitu a to N, kde N je počet řádků.
    /// </summary>
    Ako = 0,

    /// <summary>
    /// Sázenka obsahuje jedinou kardinalitu a to k, kde 2 <= k < N (N je počet řádků)
    /// </summary>
    System = 1,

    /// <summary>
    /// Sázenka obsahuje několik kardinalit
    /// </summary>
    Multi = 2,

    /// <summary>
    /// Sázenka obsahuje všechny kardinality v rozmezí 1 - N
    /// </summary>
    Full = 3
}

export enum CouponStakeType {
    /// <summary>
    /// Hráčem navržená hodnota je vložena na každý tiket kupónu. Tj. celkový vklad je
    /// násobkem navrženého vkladu a počtem tiketů.
    /// </summary>
    /// <remarks>
    /// Takto původně fungovala volba označovaná jako Vklad na kupón.
    /// </remarks>
    AllTickets = 0,

    /// <summary>
    /// Hráčem navržená hodnota je rozpočtena rovnoměrně mezi všechny tikety na kupónu. Tj.
    /// celkový vklad je roven navržené hodnotě.
    /// </summary>
    Coupon = 1,

    /// <summary>
    /// Hráčem navržená hodnota je rozpočtena rovnoměrně mezi tikety příslušné označené kardinality.
    /// Hodnota vkladu na kardinalitu je rovna přesně navrženému vkladu. Tj. celkový vklad je
    /// součtem hodnot všech označených kardinalit na kupónu.
    /// Zde aplikace může povolit modifikovat vklady na jednotlivé tikety (celkový
    /// vklad na kardinalitu je součtem, čili u modifikace konkrétního tiketu jsme schopni jednoduše
    /// modifikovat celkový vklad kardinality i celkový vklad na kupónu).
    /// </summary>

    TicketsInCardinality = 2,

    /// <summary>
    /// Hráčem navržená hodnota je vložena na každý tiket příslušné označené kardinality.
    /// Tj. celkový vklad je sumou součtů vkladů na jednotlivých kardinalitách a vklad na kardinalitu
    /// je násobkem navrženého vkladu pro tuto kardinalitu a počtu tiketů této kardinality.
    /// </summary>
    /// <remarks>
    /// Takto původně fungovala volba označovaná jako Vklad na systém, pro zákazníka Synot
    /// se volba nazývá VKLAD/ŘÁDEK.
    /// </remarks>

    AllTicketsInCardinality = 3
}

/**
 * States of coupon - adding a new value need to review conditions using values,
 * see also CouponState in baseCoupon.
 *
 * new means also with data
 * accepted - means bet was sent and accepted
 * rejected - means bet was sent and rejected with errors
 * saving is probably for Synot Sk for sms payment only
 * waitingForAccept - for prematch it's final state, for live it goes to hint ...
 *
 */
export enum CouponStatusType { New = 'new', Saving = 'saving', Pay = 'pay', Hint = 'hint', WaitingForAccept = 'waitingForAccept', Accepted = 'accepted', Rejected = 'rejected', HintAccepted = 'hintAccepted', HintRejected = 'hintRejected' };

export const CouponStatusTypeForStore = types.enumeration('CouponStatusTypeForStore', [CouponStatusType.New, CouponStatusType.Pay, CouponStatusType.Accepted, CouponStatusType.Rejected, CouponStatusType.Saving, CouponStatusType.WaitingForAccept, CouponStatusType.Hint, CouponStatusType.HintAccepted, CouponStatusType.HintRejected]);

export enum TicketStatusType {
    New = 'new', Saving = 'saving', Pay = 'pay', Hint = 'hint', Accepted = 'accepted', Rejected = 'rejected' /* Rejected is not used now  */, Saved = 'saved'
};

export enum RateChangeAcceptType { None = 'none', RateIncrease = 'rateIncrease', RatePercentageChange = 'ratePercentageChange', AnyRate = 'anyRate' };

export enum CashoutAcceptedChangeTypeUI { None = 0, Any = 1, Higher = 2 };

export const CashoutAcceptedChangeTypeUIForStore = types.union(types.literal(CashoutAcceptedChangeTypeUI.None), types.literal(CashoutAcceptedChangeTypeUI.Higher), types.literal(CashoutAcceptedChangeTypeUI.Any));


export enum ProductStakeType {
    Financial = 1,
    Loyalty = 2
}

export enum CancelBetResultType {
    None = 0,
    AlreadyCancelled = 1,
    PeriodOver = 2,
    Failed = 3,
    NotForThisPlayer = 4,
    IdentificationFailed = 5,
    Success = 6,
    Loading = 1000,
    NotInitialized = 1001
}

export enum BetStatus {
    //
    // State

    /// <summary>
    /// Na sázence bylo provedeno technické storno.
    /// </summary>
    Reversed = 1,

    /// <summary>
    /// Odstraněno sytémem (sázka byla ve stavu prepared a některý zápas již začal)
    /// </summary>
    RemovedBySystem = 2,

    /// <summary>
    /// Odstraněno hráčem (sázka byla ve stavu prepared a hráč ji chce zrušit - především z důvodu stáhnutí alarmu z dohledu při podání přes terminál)
    /// </summary>
    RemovedByPlayer = 3,

    /// <summary>
    /// Sestavovana sazenka, neni ulozena v databazi
    /// </summary>
    Created = 4,

    /// <summary>
    /// Pripravena sazenka, muze byt zaplacena
    /// </summary>
    Prepared = 5,

    /// <summary>
    /// podana sazenka (zaplacena z pohledu Platebniho Portalu)
    /// </summary>
    Paid = 6,

    /// <summary>
    /// Prijata sazenka
    /// </summary>
    Confirmed = 7,

    /// <summary>
    /// Neprijata sazenka
    /// </summary>
    Refused = 8,

    /// <summary>
    /// Sazenka byla stornovana hracem
    /// </summary>
    CanceledByPlayer = 9,

    /// <summary>
    /// Uzavrena, vyhodnocena sazenka
    /// </summary>
    Closed = 10,

    /// <summary>
    /// Jinak error (určovalo se podle Coupon.State, ale State nebyl definován)
    /// </summary>
    StateError = 11,

    //
    // EvalType

    /// <summary>
    /// Prohraná
    /// </summary>
    Lost = 12,

    /// <summary>
    /// Vyhraná
    /// </summary>
    Win = 13,

    /// <summary>
    /// Vrátit vklad s MP
    /// </summary>
    TerminatedWithMP = 14,

    /// <summary>
    /// Vrátit vklad
    /// </summary>
    Terminated = 17,

    /// <summary>
    /// Prohra s kompenzací = Kompenzace
    /// </summary>
    Compensation = 18,

    /// <summary>
    /// Jinak error (určovalo se podle Coupon.EvalType, ale EvalType nebyl definován)
    /// </summary>
    EvalError = 19,

    //
    // Win - určená z winFacade

    /// <summary>
    /// Vyhraná - vyplacená
    /// </summary>
    WinPaidOut = 20,

    //
    // Bet - určno z betFacade

    /// <summary>
    /// Vrácen vklad s MP
    /// </summary>
    TerminatedWithMPPaidOut = 22,

    /// <summary>
    /// Vrácen vklad
    /// </summary>
    TerminatedPaidOut = 23,

    /// <summary>
    /// Tech. storno, vracen vklad s MP
    /// </summary>
    TechStornoWithMPPaidOut = 24,

    /// <summary>
    /// Expirovana vyhra
    /// </summary>
    Expired = 21,

    /// <summary>
    /// Poslana zadost na odkup
    /// </summary>
    CashOutRequest = 10001,

    /// <summary>
    /// Odkup dokoncen
    /// </summary>
    CashOutClosed = 10002,

    /// <summary>
    /// Odkup dokoncen a sazenka vyplacena
    /// </summary>
    CashOutClosedPaidOut = 10003
}

export enum BetTypeAsString { Standard = "standard", Live = "Live" };
export const BetTypeAsStringForStore = types.enumeration('BetTypeAsStringForStore', [BetTypeAsString.Standard, BetTypeAsString.Live]);